/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Coming_Soon_DescriptionInputs */



/**
* | output |
* | --- |
* | "The compliance copilot will help you automatically monitor and escalate sensitive interactions." |
*
* @param {Compliance_Copilot_Coming_Soon_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_coming_soon_description = /** @type {((inputs?: Compliance_Copilot_Coming_Soon_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Coming_Soon_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Compliance-Copilot hilft Ihnen, sensible Interaktionen automatisch zu überwachen und zu eskalieren.")
	return /** @type {LocalizedString} */ ("The compliance copilot will help you automatically monitor and escalate sensitive interactions.")
});